"use client";
import { Box, Separator, SimpleGrid, Stack, Table, VStack, Text } from "@chakra-ui/react";
import { Heading } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import PricingFooter from "@/components/pricingFooter";
import { RAM_CONSTANTS } from "./constants";

// Desktop table component
const RamPricingTable = ({ option }) => {
  return (
    <Box borderWidth={"1px"} borderRadius="lg" p={4} bg="white" boxShadow={"lg"}>
      <Heading fontSize={"xl"} mb={6}>
        {option.title}
      </Heading>
      {option.desc.map((line, idx) => (
        <Text key={idx} mb={2} color="text.100">
          {line}
        </Text>
      ))}
      <Table.Root striped border="2px solid rgb(237,242,247)" width="100%" mt={6}>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader rowSpan={2} textAlign="center">
              Cloudlets
            </Table.ColumnHeader>
            <Table.ColumnHeader
              colSpan={2}
              textAlign={"center"}
              border="2px solid #EDF2F7"
            >
              Cost per Reserved Cloudlet
            </Table.ColumnHeader>
          </Table.Row>
          <Table.Row>
            <Table.ColumnHeader textAlign="center" border="2px solid #EDF2F7">
              Hourly Price
            </Table.ColumnHeader>
            <Table.ColumnHeader textAlign="center" border="2px solid #EDF2F7">
              Discount
            </Table.ColumnHeader>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {option.data.map((row, idx) => (
            <Table.Row key={idx}>
              <Table.Cell textAlign="center">{row.cloudlet}</Table.Cell>
              <Table.Cell textAlign="center" fontWeight="bold" color="primary.200">
                {row.pricing.hourly}
              </Table.Cell>
              <Table.Cell textAlign="center" color="green.500">
                {row.pricing.discount}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Box>
  );
};

// Mobile card view
const RamPricingMobileCard = ({ option }) => {
  return (
    <VStack borderWidth="1px" borderRadius="lg" p={4} bg="white" gap={4}>
      <Heading size="md">{option.title}</Heading>
      {option.desc.map((line, idx) => (
        <Text key={idx} fontSize="sm" color="gray.600">
          {line}
        </Text>
      ))}
      <SimpleGrid columns={2} gap={4} w="full">
        {option.data.map((row, idx) => (
          <Stack key={idx} gap={2} borderWidth="1px" borderRadius="md" p={3} w="full">
            <Box>
              <Text as="span" fontSize="sm" color="text.100">
                Cloudlets : {""}
              </Text>
              <Text as="span" fontWeight="medium" fontSize="md">
                {row.cloudlet}
              </Text>
            </Box>
            <Box>
              <Text as="span" fontSize="sm" color="text.100">
                Price : {""}
              </Text>
              <Text as="span" fontWeight="medium" fontSize="md">
                {row.pricing.hourly} / hour
              </Text>
            </Box>
            <Box>
              <Text as="span" fontSize="sm" color="text.100">
                Discount : {""}
              </Text>
              <Text as="span" fontWeight="medium" fontSize="md">
                {row.pricing.discount}
              </Text>
            </Box>
          </Stack>
        ))}
      </SimpleGrid>
    </VStack>
  );
};

// Main View Component
const RamPricingTables = () => {
  const { heading, options, footer } = RAM_CONSTANTS;
  const HeadingVariant = useHeadingVariant();
  return (
    <Box id="paas">
      <Heading variant={HeadingVariant} textAlign="center" mb={8}>
        {heading}
      </Heading>

      {/* Desktop View */}
      <Box display={{ base: "none", md: "block" }}>
        <SimpleGrid columns={2} gap={8}>
          {options.map((option, idx) => (
            <RamPricingTable key={idx} option={option} />
          ))}
        </SimpleGrid>
      </Box>

      {/* Mobile View */}
      <Box display={{ base: "block", md: "none" }}>
        <Stack gap={6}>
          {options.map((option, idx) => (
            <RamPricingMobileCard key={idx} option={option} />
          ))}
        </Stack>
      </Box>
      <PricingFooter {...footer} />
      <Separator borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

export default RamPricingTables;
